import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { ThemePreference } from '@shared/interfaces/theme-preference.interface';
import { setDataDarkMode } from './data.actions';
import { selectDataDarkMode } from './data.selectors';

@Injectable({ providedIn: 'root' })
export class ThemePreferenceService implements ThemePreference {
  private readonly store = inject(Store);

  readonly darkMode = toSignal(this.store.select(selectDataDarkMode), { initialValue: false });

  setDarkMode(darkMode: boolean): void {
    this.store.dispatch(setDataDarkMode({ darkMode }));
  }
}
